import React, { useState } from 'react';

import MainHeader from '../../components/main-header/main-header.component';
import Mainmenu from '../../components/menu/main-menu/main-menu.component';
import QuickActionCard from '../../components/card/quick-action-card/quick-action-card.component';
import { ReactComponent as Subject } from '../../assets/images/card-icons/subject.svg';
import { ReactComponent as Scale } from '../../assets/images/card-icons/scale.svg';
import './grading/grading.styles.scss';
import CreateSBAModal from '../sba/CreateSBAModal';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import PercentagesSetting from './PercentagesSetting';
import ComponentGuard from '../../components/component-guard/ComponentGuard';
import { LinkSBAToGradingModal } from './LinkSBAToGradingModal';
import { LinkAttendanceToGradingModal } from './LinkAttendanceToGradingModal';

export default function AcademicsDashboardPage() {
  const history = useHistory();

  const [isOpen, setIsOpen] = useState('');

  return (
    <div>
      <MainHeader />
      <div className="grading page-container">
        <div>
          <span className="h-18">Academics Dashboard</span>
          <span className="right">
            <Mainmenu />
          </span>
        </div>

        <div className="card-row-4 mt-20">
          <QuickActionCard
            description="Subjects"
            leftActionText="VIEW"
            hideAction2
            actionEvent1={() => history.push('/academic/subject')}
          >
            <Subject />
          </QuickActionCard>
          <QuickActionCard
            description="Grading scale"
            leftActionText="VIEW"
            hideAction2
            actionEvent1={() => history.push('/academic/grading-scale')}
          >
            <Scale />
          </QuickActionCard>
          <QuickActionCard
            description="Attendance"
            leftActionText="ADD"
            rightActionText="VIEW"
            actionEvent1={() => {
              history.push('/students/attendance?create=true');
            }}
            actionEvent2={() => history.push('/students/attendance')}
          >
            <Subject />
          </QuickActionCard>
          <QuickActionCard
            description="SBA"
            leftActionText="CREATE"
            actionEvent1={() => {
              setIsOpen('create-sba');
            }}
            rightActionText="VIEW"
            actionEvent2={() => history.push('/sba-subjects-view')}
          >
            <Subject />
          </QuickActionCard>

          <ComponentGuard
            allowedRoles={[
              'AcademicReportRemarksAccess',
              'AcademicReportRemarksAccessReadOnly',
            ]}
            showLoader
          >
            <QuickActionCard
              description="Remarks Management"
              leftActionText="VIEW"
              actionEvent1={() => history.push('/academic/remarks')}
              hideAction2
            />
          </ComponentGuard>
          <ComponentGuard
            allowedRoles={[
              'AcademicReportPercentagesAccess',
              'AcademicReportPercentagesAccessReadOnly',
            ]}
            showLoader
          >
            <QuickActionCard
              description="End of Term Grading %"
              leftActionText="VIEW"
              actionEvent1={() => setIsOpen('percentages')}
              hideAction2
            />
          </ComponentGuard>
          <QuickActionCard
            description="Pre School Grading"
            leftActionText="VIEW"
            actionEvent1={() => history.push('/pre-school/grading')}
            hideAction2
          />
          <QuickActionCard
            description="Primary & JHS Grading"
            leftActionText="VIEW"
            hideAction2
            actionEvent1={() => history.push('/academic/grading')}
          >
            {/* <Subject /> */}
          </QuickActionCard>
          <ComponentGuard
            allowedRoles={['AcademicReportSBAConfigurationAccess']}
          >
            <QuickActionCard
              description="Use SBA For Class Score"
              actionEvent1={() => setIsOpen('link-sba')}
              leftActionText="VIEW"
              hideAction2={true}
            />
          </ComponentGuard>

          <QuickActionCard
            description="Link Attendance To Reports"
            actionEvent1={() => setIsOpen('link-attendance')}
            leftActionText="VIEW"
            hideAction2={true}
          />

          <PercentagesSetting
            isOpen={isOpen === 'percentages'}
            closeModal={() => setIsOpen('')}
          />

          <CreateSBAModal
            isOpen={isOpen === 'create-sba'}
            closeModal={() => setIsOpen('')}
          />

          <LinkSBAToGradingModal
            isOpen={isOpen === 'link-sba'}
            closeModal={() => setIsOpen('')}
          />

          <LinkAttendanceToGradingModal
            isOpen={isOpen === 'link-attendance'}
            closeModal={() => setIsOpen('')}
          />
        </div>
      </div>
    </div>
  );
}
